export default __webpack_public_path__ + "static/image1-688856ad69f4b4d5598ee407dcfd746e.png";